import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/content";

export default function ServicesGrid({ onOpenDemo }) {
  return (
    <section className="relative py-24 lg:py-32" id="services" data-testid="home-services">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl">
          <div className="overline">Our Services</div>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">
            Everything you need to run<br/>a <span className="text-gradient-blue">modern iGaming</span> business.
          </h2>
          <p className="mt-4 text-gray-400 max-w-xl leading-relaxed">
            From platform to payments, we build the full B2B stack. Pick one service or the entire turnkey suite.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {SERVICES.map((s, i) => (
            <motion.button
              key={s.title}
              type="button"
              onClick={onOpenDemo}
              data-testid={`service-card-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
              className="card-border-hover group text-left p-7 rounded-2xl bg-[#0B1224]/70 border border-white/[0.06] hover:bg-[#0B1224]"
              style={{ transition: "transform 0.3s ease, background-color 0.3s ease" }}
            >
              <div className="flex items-start justify-between">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#2563EB]/25 to-[#7C3AED]/20 border border-[#2563EB]/30 flex items-center justify-center">
                  <s.icon className="w-5.5 h-5.5 text-[#00D4FF]" />
                </div>
                <ArrowUpRight className="w-5 h-5 text-gray-500 group-hover:text-[#00D4FF] transition-colors" />
              </div>
              <h3 className="mt-6 font-display text-xl font-semibold tracking-tight">{s.title}</h3>
              <p className="mt-2 text-sm text-gray-400 leading-relaxed">{s.desc}</p>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
